"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = exports.FancyFooter = undefined;

var _fancyFooter = require("./fancyFooter");

var _fancyFooter2 = _interopRequireDefault(_fancyFooter);

var _footer = require("./footer");

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FancyFooter = _fancyFooter2.default;
exports.Footer = _footer2.default;